import * as UI from "@iyk/ui"

import { Res } from "@iyk/vf-server"
import { Effect } from "effect"
import { appConfig } from "../../../app-config.ts"
import { GlobalRoutes } from "../../../react-router/routes.ts"
import { Handler } from "../../../server/handler.ts"
import { HeaderLogo } from "../../ui/header-logo.tsx"
import { Link } from "../../ui/link.tsx"
import { Shop } from "../shop.ts"
import { CartSummary } from "../ui/cart-summary.tsx"
import type { Route } from "./+types/cart.ts"

export const meta: Route.MetaFunction = () => [
  {
    title: `Cart | ${appConfig.artist.name}`
  },
  {
    property: "og:title",
    content: `Cart | ${appConfig.artist.name}`
  }
]

export const loader = Handler.make("shop", ({ products, cookies, carts, cookieJar }) => {
  return Effect.gen(function* () {
    const [productList, cart] = yield* Effect.all(
      [products.list, Shop.getCart({ cookies, carts, cookieJar })],
      { concurrency: "unbounded" }
    )

    return Res.json({ products: productList.map(Shop.toProduct), cart })
  })
})

export default function CartRoute({ loaderData }: Route.ComponentProps) {
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto h-dvh flex flex-col relative">
      <div className="absolute inset-0 w-full overflow-hidden select-none -z-10 h-[calc(100vh*2/3)]">
        <img
          src={appConfig.assets.images.background}
          alt="Profile Background"
          className="w-full h-full object-cover blur-md scale-110"
        />
        <div className="absolute inset-0 bg-[linear-gradient(to_top,_var(--gray-1),_rgba(0,0,0,0.7))]" />
      </div>

      <header className="h-[60px] p-4 z-30 w-full grid justify-center">
        <Link to={GlobalRoutes.profile}>
          <HeaderLogo />
        </Link>
      </header>
      <Link to={GlobalRoutes.shop.landing} className="text-xs flex items-center gap-0.5 h-[60px] px-4">
        <UI.Icon.ChevronLeft /> Back to shop
      </Link>
      <main className="flex-1 flex flex-col z-10 px-4 h-[calc(100dvh-100px)]">
        <CartSummary cart={loaderData.cart} />
      </main>
    </div>
  )
}
